import { FilterLogsArguments } from '../types';

const ALL_LOGS_KEYWORD = 'all';

function calculateLogsEndpoint(hostname = window.location.hostname) {
  const endpoint = 'https://log.clearbit.com';

  const localDevelopment = 'localhost' === hostname;
  const webLocal = 'web.local' === hostname;
  const development = /dev\.clearbit\.com$/.test(hostname);
  if (localDevelopment || webLocal || development)
    return 'https://log.dev.clearbit.com';

  const staging = /staging\.clearbit\.com$/.test(hostname);
  if (staging) return 'https://logs.staging.clearbit.com';

  return endpoint;
}

export function getLogsUrl({ api, type, status, query }: FilterLogsArguments) {
  const endpoint = calculateLogsEndpoint();

  const searchParams = new URLSearchParams({});

  if (api && api !== ALL_LOGS_KEYWORD) {
    searchParams.set('context', api);
  }

  if (type && type !== ALL_LOGS_KEYWORD) {
    searchParams.set('type', type);
  }

  if (status && status !== ALL_LOGS_KEYWORD) {
    searchParams.set('status', String(status));
  }

  if (query) {
    searchParams.set('query', query);
  }

  return `${endpoint}/v1/logs?${searchParams.toString()}`;
}
